<template>
  <div id="main">
    <article class="post">
      <div class="investorAvatar"><img :src=logo alt=""></div>
      <header>
        <div class="title">
          <h2>Welcome to Augur Investor</h2>
          <p>Please login with your email and password below.</p>
        </div>
      </header>
      <section>
        <Form class="form" v-slot="{ errors }" @submit=login>
          <div class="row gtr-uniform">
            <div class="col-12">
              <Field id="loginName" type="text" name="email" :rules="isRequired" placeholder="Email" />
              <span class="error">{{ errors.email }}</span>
            </div>
            <div class="col-12">
              <Field id="password" type="password" name="password" :rules="isRequired" placeholder="Password" />
              <span class="error">{{ errors.password }}</span>
            </div>
            <div class="col-12">
              <ul class="actions">
                <li><button id="loginButton" class="button" :class="loading && 'disabled'">Login</button></li>
              <div class="loading" v-show=loading >
                <i class="icon solid fa-sync-alt"></i>
                <span>Please wait...</span>
              </div>
              <div class="loading" v-show=error >
                <i class="icon solid fa-times-circle"></i>
                <span>{{ error }}</span>
              </div>
              </ul>
              <p>Forgot your password? <router-link :to="{ name: 'ForgotPasswordView'}" >Click here</router-link>.<br />
              Don't have an account? <a href="https://www.augurinvestor.com.au/sign-up">Register here</a>.</p>
            </div>
          </div>
        </Form>
      </section>
    </article>
  </div>
</template>

<script>
import { Field, Form } from 'vee-validate';
import logo from '@/images/Augur Logo Blue Square.svg';

export default {
  name: 'LoginView',
  components: {
    Field,
    Form,
  },
  data() {
    return {
      logo,
      loading: false,
      error: false,
    };
  },
  methods: {
    async login(values) {
      this.loading = true;
      this.error = false;
      this.$store.dispatch('login', values)
        .catch((error) => {
          console.log('error', error);
          this.loading = false;
          switch (error.code) {
            case 'auth/wrong-password':
              this.error = 'incorrect password';
              break;
            case 'auth/user-not-found':
              this.error = 'incorrect username';
              break;
            case 'auth/too-many-requests':
              this.error = 'account locked';
              break;
            default:
              this.error = 'unknown error';
          }
        });
    },
    isRequired(value) {
      return value ? true : 'This field is required';
    },
  },
  watch: {
    $route() {
      this.$store.commit('clearTemporaryAvatar');
    },
  },
};
</script>
